import React, { Component } from "react";
import {
  Box,
  Button,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import type { DashboardExport, DashboardFilterOptions, DashboardPageExport, DashboardPageRefresh, DashboardRefresh, DashboardSharedFilters } from "./dashboard.types";
import ClearableSelectField from "../../components/dashlibs/ClearableSelectField";

export interface DashboardHeaderProps {
  userData:any;
  sharedFilters?: DashboardSharedFilters;
  filterOptions?: DashboardFilterOptions; 
  onFilterChange?: Function; 
  //onRefresh: Function;
  title?: string;
  subtitle?: string;
  period?: string;
  scenario?: string;
  costcenter?: string;
  location?: string;
  onRefresh?: DashboardPageRefresh;
  onExport?: DashboardPageExport;
}

export type State = any;

export default class DashboardHeader extends Component<DashboardHeaderProps,State> {


// export default function DashboardHeader({
//   userData,
//   sharedFilters, 
//   filterOptions, 
//   onFilterChange, 
//   //onRefresh,
//   title = "Dashboard exécutif",
//   subtitle = "Vue consolidée des budgets, de l’exécution, des performances et des alertes.",
//   // period = "S1 2025",
//   // scenario = "Révisé",
//   // costcenter = "Tous",
//   // location = "Tous",
//   onRefresh,
//   onExport,
// }: DashboardHeaderProps) {

// onRefresh = async(e:any) => {
//   const {onRefresh} = this.props;
//   if (onRefresh) {
//     await onRefresh();
//   }
// };
onChange = (filter:string) => (e:any) => this.props.onFilterChange?.({ [filter]: e.target?.value });

render(){
  const {title,subtitle} = this.props;
  const {userData,sharedFilters,filterOptions,onFilterChange,onRefresh,onExport} = this.props;
  
  const {period,cycle,scenario,costcenter,location} = sharedFilters || {};
  const {periods=[],cycles=[],scenarios=[],costcenters=[],locations=[]} = filterOptions || {};
  return (
    <Box>
      <Stack
        direction={{ xs: "column", lg: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", lg: "center" }}
        spacing={2}
      >
        <Box>
          <Typography
            sx={{
              fontSize: { xs: 28, md: 34 },
              fontWeight: 800,
              lineHeight: 1.15,
              color: "#17324D",
              letterSpacing: "-0.03em",
            }}
          >
            {title}
          </Typography>

          <Typography sx={{ mt: 0.75, fontSize: 14, color: "#66788A", lineHeight: 1.7 }}>
            {subtitle}
          </Typography>
        </Box>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25}>
          <Button variant="outlined" startIcon={<RefreshOutlinedIcon />} onClick={onRefresh}>
            Actualiser
          </Button>
          <Button variant="contained" startIcon={<DownloadOutlinedIcon />} onClick={onExport}>
            Exporter
          </Button>
        </Stack>
      </Stack>

      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={1.25}
        sx={{ mt: 2.5 }}
      >
        {/* <TextField select label="Période" value={period || ""} onChange={this.onChange('period')} sx={{ minWidth: 180 }}>
          {periods.map((v) => (
            <MenuItem key={v.shc} value={v.shc}>
              {v.nam}
            </MenuItem>
          ))}
        </TextField> */}
        <ClearableSelectField
          label="Période"
          value={period || ""}
          options={periods}
          allLabel=""
          //onChange={(value) => onFilterChange({ costcenter: value })}
          onChange={this.onChange('period')}
          minWidth={180}
        />

        {/* <TextField select label="Cycle" value={cycle || ""} onChange={this.onChange('cycle')} sx={{ minWidth: 180 }}>
          {cycles.map((v) => (
            <MenuItem key={v.shc} value={v.shc}>
              {v.nam}
            </MenuItem>
          ))}
        </TextField> */}
        <ClearableSelectField
          label="Cycle"
          value={cycle || ""}
          options={cycles}
          allLabel=""
          //onChange={(value) => onFilterChange({ costcenter: value })}
          onChange={this.onChange('cycle')}
          minWidth={180}
        />

        {/* <TextField select label="Scénario" value={scenario || ""} onChange={this.onChange('scenario')} sx={{ minWidth: 160 }}>
          {scenarios.map((v) => (
            <MenuItem key={v.shc} value={v.shc}>
              {v.nam}
            </MenuItem>
          ))}
        </TextField> */}
        <ClearableSelectField
          label="Scénario"
          value={scenario || ""}
          options={scenarios}
          allLabel=""
          //onChange={(value) => onFilterChange({ costcenter: value })}
          onChange={this.onChange('scenario')}
          minWidth={160}
        />

        {/* <TextField select label="Centre de coûts" value={costcenter || ""} onChange={this.onChange('costcenter')} sx={{ minWidth: 220 }}>
          {costcenters.map((v) => (
            <MenuItem key={v.shc} value={v.shc}>
              {v.nam}
            </MenuItem>
          ))}
        </TextField> */}
        <ClearableSelectField
          label="Centre de coûts"
          value={costcenter || ""}
          options={costcenters}
          allLabel=""
          //onChange={(value) => onFilterChange({ costcenter: value })}
          onChange={this.onChange('costcenter')}
          minWidth={220}
        />

        {/* <TextField select label="Localisation" value={location || ""} onChange={this.onChange('location')} sx={{ minWidth: 180 }}>
          {locations.map((v) => (
            <MenuItem key={v.shc} value={v.shc}>
              {v.nam}
            </MenuItem>
          ))}
        </TextField> */}
        <ClearableSelectField
          label="Localisation"
          value={location || ""}
          options={locations}
          allLabel="All Cost Centers"
          //onChange={(value) => onFilterChange({ costcenter: value })}
          onChange={this.onChange('location')}
          minWidth={180}
        />
      </Stack>
    </Box>
  );
}
}
